// Content types screen: rename and switch sections on or off.
export const typesEn = {
  'types.subtitle': 'Rename the sections of your site or switch them off. Changes appear on the website after the next rebuild.',
  'types.subtitle.content': 'Journal, news and your own article sections: rename them or switch them off. Changes appear on the website after the next rebuild.',
  'types.subtitle.catalogue': 'Your catalogue sections and their categories: rename them or switch them off. Changes appear on the website after the next rebuild.',
  'types.media.description': 'Every image and file used on the website. Your package includes a set amount of storage.',
  'types.media.used': '{used} MB of {limit} MB used',
  'types.media.usedOnly': '{used} MB used',
  'types.media.open': 'Open Media Library',
  'layout.nav.contentSettings': 'Content Settings',
  'types.col.name': 'Section',
  'types.col.kind': 'Layout',
  'types.col.entries': 'Entries',
  'types.col.status': 'Status',
  'types.col.actions': 'Actions',
  'types.kind.catalogue': 'Catalogue (categories and items)',
  'types.kind.cards': 'Cards',
  'types.kind.articles': 'Articles',
  'types.entries': '{items} items',
  'types.entriesCategories': '{items} items · {categories} categories',
  'types.on': 'On',
  'types.off': 'Off',
  'types.rename': 'Rename',
  'types.switchOff': 'Switch off',
  'types.switchOn': 'Switch on',
  'types.switchOff.title': 'Switch off {name}?',
  'types.switchOff.body': 'It disappears from the menu, the CMS and the website. Nothing is deleted; switch it on again to bring it back.',
  'types.toast.off': '{name} switched off',
  'types.toast.on': '{name} switched on',
  'types.toast.renamed': 'Names saved',
  'types.lockedRename': 'Renaming is not part of your package.',
  'types.lockedToggle': 'Switching sections on or off is not part of your package.',
  'types.rename.title': 'Rename {name}',
  'types.rename.hint': 'Leave a field empty to use the default wording.',
  'types.rename.singular': 'One item',
  'types.rename.plural': 'Many items',
  'types.rename.categorySingular': 'One category',
  'types.rename.categoryPlural': 'Many categories',
  'types.rename.default': 'Default: {value}',
  'types.rename.submit': 'Save names',
  'types.off.title': '{name} is switched off',
  'types.off.hint': 'This section is hidden from the website. Switch it on again in Catalogue Settings.',
  'types.off.action': 'Open Catalogue Settings',
  'layout.nav.catalogueSettings': 'Catalogue Settings',
  'types.swatches.description': 'Shown throughout the CMS and on the public site.',
  'types.swatches.kinds': 'Kinds: {material}, {finish}',
  'types.swatches.plural': 'Materials & Finishes',
  'types.swatches.material': 'Materials',
  'types.swatches.finish': 'Finishes',
} as const

export const typesId: Record<keyof typeof typesEn, string> = {
  'types.subtitle': 'Ubah nama bagian situs Anda atau matikan bagian tersebut. Perubahan muncul di website setelah build berikutnya.',
  'types.subtitle.content': 'Jurnal, berita, dan bagian artikel Anda sendiri: ubah namanya atau matikan. Perubahan muncul di website setelah build berikutnya.',
  'types.subtitle.catalogue': 'Bagian katalog dan kategorinya: ubah namanya atau matikan. Perubahan muncul di website setelah build berikutnya.',
  'types.media.description': 'Semua gambar dan file yang dipakai di website. Paket Anda mencakup kapasitas penyimpanan tertentu.',
  'types.media.used': '{used} MB dari {limit} MB terpakai',
  'types.media.usedOnly': '{used} MB terpakai',
  'types.media.open': 'Buka Pustaka Media',
  'layout.nav.contentSettings': 'Pengaturan Konten',
  'types.col.name': 'Bagian',
  'types.col.kind': 'Tata letak',
  'types.col.entries': 'Isi',
  'types.col.status': 'Status',
  'types.col.actions': 'Aksi',
  'types.kind.catalogue': 'Katalog (kategori dan item)',
  'types.kind.cards': 'Kartu',
  'types.kind.articles': 'Artikel',
  'types.entries': '{items} item',
  'types.entriesCategories': '{items} item · {categories} kategori',
  'types.on': 'Aktif',
  'types.off': 'Mati',
  'types.rename': 'Ubah nama',
  'types.switchOff': 'Matikan',
  'types.switchOn': 'Aktifkan',
  'types.switchOff.title': 'Matikan {name}?',
  'types.switchOff.body': 'Bagian ini hilang dari menu, CMS, dan website. Tidak ada yang dihapus; aktifkan lagi untuk memunculkannya kembali.',
  'types.toast.off': '{name} dimatikan',
  'types.toast.on': '{name} diaktifkan',
  'types.toast.renamed': 'Nama disimpan',
  'types.lockedRename': 'Mengubah nama tidak termasuk dalam paket Anda.',
  'types.lockedToggle': 'Mengaktifkan atau mematikan bagian tidak termasuk dalam paket Anda.',
  'types.rename.title': 'Ubah nama {name}',
  'types.rename.hint': 'Kosongkan kolom untuk memakai kata bawaan.',
  'types.rename.singular': 'Satu item',
  'types.rename.plural': 'Banyak item',
  'types.rename.categorySingular': 'Satu kategori',
  'types.rename.categoryPlural': 'Banyak kategori',
  'types.rename.default': 'Bawaan: {value}',
  'types.rename.submit': 'Simpan nama',
  'types.off.title': '{name} dimatikan',
  'types.off.hint': 'Bagian ini disembunyikan dari website. Aktifkan lagi di Pengaturan Katalog.',
  'types.off.action': 'Buka Pengaturan Katalog',
  'layout.nav.catalogueSettings': 'Pengaturan Katalog',
  'types.swatches.description': 'Tampil di seluruh CMS dan di situs publik.',
  'types.swatches.kinds': 'Jenis: {material}, {finish}',
  'types.swatches.plural': 'Bahan & Finishing',
  'types.swatches.material': 'Bahan',
  'types.swatches.finish': 'Finishing',
}
